import React, { useState,Component } from "react";
import GoogleMapReact from "google-map-react";
import axios from "axios";

import "./Contact.scss";

const AnyReactComponent = ({ text }) => <div>{text}</div>;


class Contact extends Component   {
  constructor() {
    super();
    this.scrollPage(); 
    this.state = {
      email: "",
      phone: "",
      name:"",
      paragraph:""
      
    };

  }

  onChange = e => {
    /*
      Because we named the inputs to match their
      corresponding values in state, it's
      super easy to update the state
    */
    this.setState({ [e.target.name]: e.target.value });
  };
  onSubmit = e => {
    e.preventDefault();
    // get our form data out of state
    const { email, phone,name, paragraph} = this.state;
    const type="contact"
    const subject = "Inquery Email"
    const to = "info@logipool.in"
    const from = "logipooltraining@gmail.com"

    axios.post("http://167.99.234.75:54312/email/sendEmail", { email, phone ,type,subject,to ,from,name, paragraph }).then(result => {
      //access the results here....
      alert("Thank you so much....! we will contact you.");
      this.setState({
        email: "",
        phone: "",
        name:"",
        paragraph:""
      });
      
    });
  };


  scrollPage(){
    window.scrollTo({
      top: 0,
     
  });
  }

  render() {
    const { email, phone ,name, paragraph } = this.state;
  return (
    <div className="contact">
      <div className="hero_section">
        <div className="hero_content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6"></div>
              <div className="col-md-6 form-content">
                <div className="form-inner-content">
                  <h3>Contact us</h3>
                  <form onSubmit={this.onSubmit}>
                    <input type="text" name="name" value={name} onChange={this.onChange} placeholder="Name" />
                    <br />
                    <input type="email" name="email" value={email} onChange={this.onChange} placeholder="Email" />
                    <br />
                    <input type="phone" name="phone" value={phone} onChange={this.onChange} placeholder="Phone" />
                    <br />
                    <input type="text" name="paragraph" value={paragraph} onChange={this.onChange} placeholder="How can we help?" />
                    <br />

                    <div className="submitSection">
                      {/* <a href="">Submit</a> */}
                      <button type="submit">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ height: "400px", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyDHwgR6GMuAWeuQRfDX-IxU_T4CQqRWUjc" }}
          defaultCenter={{ lat: 59.95, lng: 30.33 }}
          defaultZoom={11}
        >
          <AnyReactComponent lat={59.955413} lng={30.337844} text="My Marker" />
        </GoogleMapReact>
      </div>

      <div className="info">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="leftSection">
                <div className="heading">
                  <h1>Call Us</h1>
                </div>
                <div className="content">
                  <div className="imgSection">
                    <img src={require("../../images/phone.png")} alt="" />
                  </div>
                  <div className="details">
                    <h3> 7998040404 / 7998050505</h3>
                    <p>Don't hesitate to contact us!</p>
                  </div>
                </div>
                <div className="content">
                  <div className="imgSection">
                    <img src={require("../../images/time.png")} alt="" />
                  </div>
                  <div className="details">
                    <h3>Working time</h3>
                    <p>Mon - sun: 9:00 - 19:00 </p>
                  </div>
                </div>

              </div>
            </div>
            <div className="col-md-6">
              <div className="rightSection">
                <img src={require("../../images/contact man.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
};

export default Contact;
